import { Box, Stack, Typography, Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";

import { icons } from "assets/AssetHelper";
import { useThemePalette } from "common/hooks/theme_palette";

import Loader from "components/Atoms/SharedComponents/Loader/Loader";
import { forgetPasswordSchema } from "common/utils/schemas";
import { OTPRequest } from "services/modules/authenticate";
import { AppForm, AppFormField, SubmitButton } from "components/Molecules/Form";
import { useNavigate } from "react-router-dom";

export default function ForgetPasswordForm({
  hideIcon,
  setResetPasswordStep,
  customAction = false,
  userType = "admin_user",
}) {
  const { t } = useTranslation();
  const { gray } = useThemePalette();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { load } = useSelector((state) => state?.authenticate);

  const handleFormSubmit = (values, { setSubmitting }) => {
    const action = (data) => {
      localStorage.setItem("forgetPasswordEmail", values.email);
      if (customAction) {
        setResetPasswordStep({ action: true, step: 2 });
      } else {
        navigate("/verify-otp");
      }
    };
    setSubmitting(false);
    const requestBody = {
      body: {
        user: {
          email: values.email,
        },
      },
      action,
    };
    dispatch(OTPRequest({ ...requestBody, user_type: userType }));
  };

  return (
    <>
      <Loader open={load?.loading} />
      <Stack sx={{ gap: 5 }}>
        {!hideIcon && (
          <>
            <Box
              component="img"
              src={icons.lockIcon}
              sx={{ width: "60px", height: "80px" }}
            />
            <Stack sx={{ gap: 2 }}>
              <Typography fontFamily="Cairo" fontSize="32px" fontWeight="400">
                {t("auth.forget_password.title")}
              </Typography>
              <Typography fontFamily="Cairo" fontSize="18px" color={gray}>
                {t("auth.forget_password.subtitle")}
              </Typography>
              <Divider sx={{ border: "1px solid #F5F5F5" }} />
            </Stack>
          </>
        )}
        {/* --------------------- FORM --------------------- */}
        <AppForm
          initialValues={{ email: "" }}
          validationSchema={forgetPasswordSchema}
          onSubmit={(values, { setSubmitting }) => {
            handleFormSubmit(values, { setSubmitting });
          }}
        >
          <Stack sx={{ gap: 5 }}>
            <AppFormField
              label={t("auth.forget_password.email_label")}
              name="email"
              type="text"
              labelStyle={{ fontSize: "18px" }}
              placeholder={t("auth.forget_password.email_placeholder")}
            />

            <Stack sx={{ gap: 4 }}>
              <SubmitButton>{t("auth.forget_password.submit")}</SubmitButton>
            </Stack>
          </Stack>
        </AppForm>
      </Stack>
    </>
  );
}
